<template>
  <transition name="fade">
    <div
      v-if="isOpen"
      ref="modal"
      :style="coordinatesModal.style"
      class="ui-chess-menu"
      v-click-outside="{
              handler: close,
              events: ['mousedown']
            }"
  >
      <template v-if="hasRoom && selectCount < 2">
        <p v-if="roomTitle" class="ui-chess-menu-title">{{ roomTitle }}</p>
        <p v-if="roomPrice" class="ui-chess-menu-price">{{ roomPrice }}</p>
        <p v-if="roomArea" class="ui-chess-menu-area">{{ roomArea }}</p>
        <ui-badge
            v-if="roomStatus"
            :badge="roomStatus"
            class="ui-chess-menu-status"
        />
      </template>
      <p
        v-else
        class="ui-chess-menu-select-count"
      >{{ selectCountTitle }}</p>
      <template v-if="grades.length">
        <div class="ui-chess-menu-line-break"></div>
        <div class="ui-chess-menu-grades">
          <div
            class="ui-chess-menu-grades__item"
            v-for="grade in grades"
            :key="grade.name"
          >
            <div
              class="ui-chess-menu-grades__status"
              :style="getGradeStyle(grade)"
            />
            <div class="ui-chess-menu-grades__title">
              {{ grade.name }}
              <template v-if="grade.count">
                ({{ grade.count }})
              </template>
            </div>
          </div>
        </div>
      </template>
      <template v-if="!isHoverMenu">
        <div class="ui-chess-menu-line-break"></div>
        <ui-select
            title="Действия"
            :list="listActions"
            title-field-name="value"
            :position="dropdownPosition"
            custom-filter
            small
            @custom-event="close"
        />
      </template>
    </div>
  </transition>
</template>

<script>
// TODO Поменять на UiButtonSelect
import UiSelect from '../select/UiSelect.vue'
import UiBadge from '../badge/UiBadge.vue'

import { getCurrency } from '../../libs/helpTools'
import COLORS from '../../libs/colors'

export default {
  name: 'UiChessMenu',
  components: {
    UiBadge,
    UiSelect
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    isHoverMenu: {
      type: Boolean,
      default: false
    },
    listActions: {
      type: Array,
      default: () => ([])
    },
    selectCount: {
      type: Number,
      default: 0
    },
    room: {
      type: Object,
      default: () => ({})
    },
    event: {
      type: [MouseEvent, Object],
      default: () => ({})
    }
  },

  data () {
    return {
      coordinatesModal: {},
      dropdownPosition: 'bottom'
    }
  },

  computed: {
    selectCountTitle () {
      return `Выбрано: ${this.selectCount}`
    },

    roomTitle () {
      return this.room.name || `${this.room.room_count ? this.room.room_count + 'к ' : ''}${this.room.type} №${this.room.number}`
    },

    roomPrice () {
      if (!this.room.price) return
      return getCurrency(this.room.price)
    },

    roomArea () {
      const {
        area,
        price
      } = this.room
      if (!area) return
      if (area && !price) return `${area}м²`
      return `${area}м² - ${(price / area).toFixed(0)} ₽/м²`
    },

    hasRoom () {
      // eslint-disable-next-line no-unreachable-loop
      for (const key in this.room) {
        return true
      }
      return false
    },

    roomStatus () {
      if (!this.room.status_name) return
      return {
        name: this.room.status_name,
        text_color: this.room.text_color,
        bg_color: this.room.bg_color
      }
    },

    grades () {
      return this.room.grades || []
    }
  },

  methods: {
    getGradeStyle (grade) {
      return { backgroundColor: grade.color || COLORS.blue1 }
    },

    close () {
      this.$emit('close')
    },

    setCoordinates () {
      this.$nextTick(() => {
        this.dropdownPosition = 'bottom'
        const margin = 20
        const { pageX, pageY, clientY } = this.event
        const container = document.querySelector('.ui-chess-body-wrap')
        const containerPosition = container.getBoundingClientRect()
        const modalPosition = this.$refs.modal.getBoundingClientRect()
        let style = ''
        const diffX = document.documentElement.offsetWidth - pageX
        const diffY = Math.min(document.documentElement.offsetHeight, containerPosition.height) - pageY + document.documentElement.scrollTop - margin
        let left = pageX - containerPosition.left + margin + container.scrollLeft
        let top = pageY - document.documentElement.scrollTop - containerPosition.top + margin

        if (pageX < containerPosition.left + modalPosition.width && !this.isHoverMenu) {
          left = margin
        } else if (diffX < modalPosition.width) {
          left = pageX - modalPosition.width + container.scrollLeft - containerPosition.left - margin
        }
        if (pageY < containerPosition.top + modalPosition.height) {
          top = margin
        } else if (diffY < modalPosition.height + margin || containerPosition.height < diffY) {
          top = clientY - modalPosition.height - containerPosition.top - margin
          this.dropdownPosition = 'top'
          const maxTop = containerPosition.height - modalPosition.height - margin
          if (top > maxTop) {
            top = maxTop
          }
        }

        style = `left: ${left}px;top: ${top}px;`
        this.coordinatesModal = {
          style,
          isCustom: true
        }
      })
    }
  },

  watch: {
    isOpen (value) {
      if (value) {
        this.setCoordinates()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-chess-menu {
  position: absolute;
  height: auto;
  min-width: 280px;
  max-width: 300px;
  padding: 24px 16px;
  background-color: white;
  border-radius: $border-radius-00;
  box-shadow: 0 2px 7px rgba($black-01, 0.25);
}

.ui-chess-menu {
  &-line-break {
    height: 1px;
    width: 100%;
    background-color: $gray-5;
    margin: 12px 0;
  }

  &-select-count {
    font-weight: 500;
    margin-bottom: 0;
  }

  &-title {
    @include font-16;

    margin-bottom: 8px;
    font-weight: 500;
  }

  &-price {
    @include font-title-18;
    margin-bottom: 2px;
  }

  &-area {
    @include font-14;
    margin-bottom: 0;

    color: $gray-4;
  }

  &-status {
    margin: 12px 0 0;
  }

  &-grades {
    @include grid;
    grid-gap: 5px;

    &__item {
      display: flex;
      align-items: center;
      gap: 6px;
    }

    &__status {
      flex-shrink: 0;
      height: 10px;
      width: 10px;
      margin: 4px;
      border-radius: 50%;
    }

    &__title {
      @include font-14;
      color: $gray-2;
    }
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
